import React from 'react'

import { LoadingPanel } from '~/components/elements/LoadingPanel'

export const LoadingPage = () => <LoadingPanel containerSize="full" />
